(function () {
    'use strict';
    angular.module('ib-pmt-services-http-module', [
        'pmt-payment-scripts-service',
        'pmt-customer-cards-fees-service'
    ]);
})();